var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"align-center pb1 fira-sans-light-italic mt1"},[_vm._v("\n    Already have an Account?\n    "),_c('a',{staticClass:"light-green-text fw-lb",on:{"click":function($event){return _vm.goToLogin()}}},[_vm._v("Login Here")])])}
var staticRenderFns = []

export { render, staticRenderFns }